import React, { useEffect, useState } from "react";

import { Box, Typography } from "@mui/material";
import { Title } from "../Components/Product/Title/Title";
import { CollapseProductDetail } from "../Components/Product/Form/ProductDetail/ProductDetail";
import { ProductForm } from "../Components/Product/Form/ProductDetail/ProductForms/DetailForm";
import { MetaFieldForm } from "../Components/Product/Form/ProductDetail/MetaFieldForm/MetaFieldForm";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { getSingleProduct } from "../Store/Features/SingleProduct/SingleProduct";
import CircularProgress from '@mui/material/CircularProgress';
export const Product = () => {
  const dispatch = useDispatch();
  const { slug } = useParams();
  const Product = useSelector(state => state.singleProductSlice.value);
  const Loading = useSelector(state => state.singleProductSlice.loading);
  function isObjEmpty(obj) {
    return Object.keys(obj).length === 0;
  }


  useEffect(() => {
    if (isObjEmpty(Product)) {
      dispatch(getSingleProduct(slug));
    }
  }, []);


  return (
    <Box className="main_container df-c-20" >
      {Loading ? (<Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", justifyContent: "center", height: "80vh" }}><CircularProgress /></Box>) : (
        <>
          <Title id={Product.id} active={Product.is_active} />
          <Box className="df-c-20">
            <CollapseProductDetail Title="Product Details">
              <ProductForm {...Product} />
            </CollapseProductDetail>
            <CollapseProductDetail Title="Metafields">
              <MetaFieldForm {...Product} />
            </CollapseProductDetail>
          </Box>
        </>
      )
      }

    </Box >
  );
};